import React, { useEffect, useRef } from "react";
import emailjs from '@emailjs/browser';
import "./ContactMe.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import copyright from './../assets/copyright.svg'

const ContactMe = () => {

  useEffect(() => {

  }, []);

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_jqm0hxo', 'template_5szhtqo', form.current, 'qtWY2XXA6U_ppwCDf')
      .then((result) => {
          console.log(result.text);
          toast("Mail Sent Successfully");
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  };

  return (
    <div className="contact-container">
      <div className="hl-0"></div>
      <div className="hl-1"></div>
      <div className="hl-2"></div>
      <div className="hl-3"></div>
      <div className="contact-btn-container">
        <button className="work"><Link to={'/contact-us'} style={{ textDecoration: 'none', color: '#fff' }}>
          Work Together</Link><i class="icon-next"></i>
        </button>
      </div>
      <div className="contact-header">
        Get&nbsp;<span style={{ color: "#c5a47e" }}> In Touch</span>
      </div>
      <div className="contact-wrapper">
        <div className="left-info-wrapper">
          <p>+91 9888211088</p>
          <p>chawla_strdesignengg@yahoo.co.in</p>
        </div>
        <div className="form-wrapper">
          <form ref={form} onSubmit={sendEmail}>
            <div className="combo">
              <div className="name">
                <input type="text" placeholder="Name" name="user_name" />
              </div>
              <div className="email">
                <input type="text" placeholder="Email Address *" name="user_email" />
              </div>
              <div className="phone">
                <input type="text" placeholder="Phone" name="user_phone" />
              </div>
              <div className="company">
                <input type="text" placeholder="Company" name="user_company" />
              </div>
            </div>
            <div className="message">
              <input type="textarea" placeholder="Message *" name="message" />
            </div>
            <button type="submit" className="send-btn">
              Send
            </button>
          </form>
        </div>
      </div>
      <div className="footer">
        <div className="footer-wrapper">
            <div className="footer-name">Chawla Structural Design Engineers & Consultant</div>
            <div className="footer-name">Atul Chawla</div>
            <div className="footer-name"><img src={copyright} alt="" className="copyright" style={{'height': '12px', 'width': '12px'}} /> Chawla Structural Design Engineers & Consultant 2003. All Rights Reserved</div>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
